import { Component, OnInit } from '@angular/core';
import { ABCisTableModel, ColumnType } from 'src/app/components/abcis-table/abcis-table.component';
import { ABCisApi } from 'src/app/handlers/apiHandler.service';

@Component({
  selector: 'app-global-supplier-type-config',
  standalone: false,
  templateUrl: './global-supplier-type-config.component.html'
})
export class GlobalSupplierTypeConfigComponent implements OnInit {
  tableConfig: ABCisTableModel;

  rowData: any;
  promptValue: string;
  displayPromptModal = false;
  modalHeader: string;

  ngOnInit() {
    this.SetTableConfig();
  }

  SetTableConfig() {
    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: 'global-supplier-type-configuration',
        approxamateRowCount: 1000,
        anyParams: true
      },
      colConfig: [
        { field: 'globalSupplierId', header: 'Global Supplier', type: ColumnType.MultiSelectComplex, setUrl: 'global-supplier/lookup', isReadonly: true, isPrimary: true  },
        { field: 'documentTypeCode', header: 'Document Type', type: ColumnType.DropDown, setUrl: 'document-type/lookup', isPrimary: true },
        { field: 'skipLineItems', header: 'Skip Line Items', type: ColumnType.Boolean },
        { field: 'isUseOrderCost', header: 'Use Order Cost', type: ColumnType.Boolean },
        { field: 'searchRegex', header: 'Search Regex', type: ColumnType.String },
        { field: 'lineItemChannelOrderId', header: 'Line Item Channel Order', type: ColumnType.DropDown, setUrl: 'line-item-channel-order/lookup' },
        { field: 'prompt', header: 'Category, Header & Line Item Prompt', type: ColumnType.TextArea, isLink: true },
        { field: 'overrideDefaultSupplierType', header: 'Override Default Supplier Type', type: ColumnType.Boolean },
        { field: 'supplierTypePrompt', header: 'Supplier Type Prompt', type: ColumnType.TextArea, isLink: true }
      ],
      addFormConfig: {
        header: 'Add Global Supplier Type'
      },
      isConfigurable: true
    };
  }

  onLinkClick(event: any) {
    this.rowData = event.value;
    switch(event.column) {
      case 'prompt':
        this.promptOnClick(this.rowData.prompt);
        break;
      case 'supplierTypePrompt':
        this.promptOnClick(this.rowData.supplierTypePrompt);
        break;
   }
}

  promptOnClick(prompt: string) {
    this.promptValue = prompt;
    this.modalHeader = `Prompt for Global Supplier ID ${this.rowData.globalSupplierId}:` ;
    this.displayPromptModal = true;
  }
}

class DocumentType {
  documentTypeCode: string;
  documentTypeName: string;
}
